module.exports = __webpack_public_path__ + "img/celestia.417375bd.jpg";